<template>
  <div class="tab-content" v-if="positionDetail">
    <div
      v-if="
        coCreationVO.coCreationFlag &&
          (!coCreationRewardDetail.hasOrder ||
            coCreationRewardDetail.guidanceService == 0 ||
            coCreationRewardDetail.guidanceService == null) &&
          positionDetail.ifCanJoinCoCreation &&
          coCreationVO.coCreationScore >= 80 &&
          (!positionDetail.ccBlackListFlagDTO ||
            (positionDetail.ccBlackListFlagDTO &&
              !positionDetail.ccBlackListFlagDTO.isCompanyInCcBlack))
      "
      class="co-cr-order"
    >
      <img src="../../assets/survey-bg.png" />
      <div class="content">
        <div class="left"></div>
        <div class="right" @click="showTips">
          <p class="p1">
            共创补贴<van-icon class="wenhao" name="question-o" />
          </p>
          <p class="p2">{{ noGuidanceRewardView }}</p>
        </div>
      </div>
      <div class="bottom-tip">
        <p>友情提示：请至猎上网电脑端操作“共创”设置</p>
        <p>hh.hunteron.com</p>
      </div>
    </div>
    <div
      class="co-cr-guidance"
      v-if="
        coCreationVO.coCreationFlag &&
          coCreationRewardDetail.hasOrder &&
          coCreationRewardDetail.guidanceService === 2 &&
          (!positionDetail.ccBlackListFlagDTO ||
            (positionDetail.ccBlackListFlagDTO &&
              !positionDetail.ccBlackListFlagDTO.isCompanyInCcBlack))
      "
    >
      <img src="../../assets/guidance-service-bg.png" />
    </div>
    <div>
      <div class="tab-box" v-if="showFullDetail">
        <h2 class="tab-title">做单须知</h2>
        <ul class="tab-list">
          <li>
            <label>简历模版</label>
            <div
              class="box"
              v-if="
                coCreationVO.enterpriseVO &&
                  (coCreationVO.enterpriseVO.templateType == 1 ||
                    coCreationVO.enterpriseVO.templateType == 2 ||
                    (coCreationVO.enterpriseVO.templateFile &&
                      coCreationVO.enterpriseVO.templateFile.url))
              "
            >
              <span
                v-if="
                  coCreationVO.enterpriseVO &&
                    coCreationVO.enterpriseVO.templateType == 1
                "
                >必须使用“企业简历模板”</span
              ><span
                v-if="
                  coCreationVO.enterpriseVO &&
                    coCreationVO.enterpriseVO.templateType == 2
                "
                >推荐使用“猎上标准模板”</span
              >
              <p
                v-if="
                  coCreationVO.enterpriseVO &&
                    coCreationVO.enterpriseVO.templateFile &&
                    coCreationVO.enterpriseVO.templateFile.url
                "
              >
                <b class="red">《简历模板》请至PC下载</b>
              </p>
            </div>
            <div class="box">-</div>
          </li>
          <li>
            <label>查重方式</label>
            <div class="box">{{ coCreationVO.reCheckRepeat || "-" }}</div>
          </li>
          <li>
            <label>推荐方式</label>
            <div class="box">{{ coCreationVO.reHrSystem || "-" }}</div>
          </li>
          <!-- <li>
            <label>竞业限制</label>
            <div class="box">
              <span>{{ coCreationVO.reBusinessStrifeLimit || "-" }}</span>
            </div>
          </li> -->
          <li>
            <label>其他说明</label>
            <div class="box">{{ coCreationVO.reOther || "-" }}</div>
          </li>
          <li>
            <label>客户亮点</label>
            <div class="box">{{ coCreationVO.lightspotCompany || "-" }}</div>
          </li>
          <li>
            <label>做单亮点</label>
            <div class="box">{{ coCreationVO.lightspotData || "-" }}</div>
          </li>
        </ul>
      </div>
      <div class="tab-box">
        <h2 class="tab-title">职位说明</h2>
        <ul class="tab-list">
          <li v-if="positionDetail.openReason">
            <label>开放原因</label>
            <div v-if="positionDetail.openReason" class="box">
              <span>{{ openReasonTypeMap[positionDetail.openReason] }}</span>
            </div>
            <div v-else class="box">-</div>
          </li>
          <li
            v-if="
              positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean.openReasonInfo
            "
          >
            <label>详细说明</label>
            <div class="box">
              <span>{{
                positionSurveyView.positionSurveyBaseBean.openReasonInfo || "-"
              }}</span>
            </div>
          </li>
          <li>
            <label>开放时间</label>
            <div class="box">{{ coCreationVO.openTime || "-" }}</div>
          </li>
          <!-- <li>
            <label>过程情况</label>
            <div class="box">
              <p v-if="coCreationVO.processDetail">
                <span v-if="coCreationVO.processDetail">{{
                  coCreationVO.processDetail
                }}</span
                ><span
                  style="color: rgba(0,0,0,0.6)"
                  v-if="
                    coCreationVO.processUpdateTime ||
                      (positionDetail.spaViews &&
                        positionDetail.spaViews.length)
                  "
                  >（<span v-if="coCreationVO.processUpdateTime"
                    >最近更新时间：{{
                      coCreationVO.processUpdateTime | roughFriendlyDate
                    }}</span
                  >&nbsp;<span
                    v-if="
                      positionDetail.spaViews && positionDetail.spaViews.length
                    "
                    >PA：{{ positionDetail.spaViews[0].userName }}</span
                  >）
                </span>
                <span></span>
              </p>
              <p v-else>-</p>
            </div>
          </li> -->
          <li>
            <label>招聘人数</label>
            <div class="box">
              <span>{{
                positionDetail.headCount ? positionDetail.headCount + "人" : "-"
              }}</span>
            </div>
          </li>
          <li
            v-if="positionDetail.locations && positionDetail.locations.length"
          >
            <label>工作地点</label>
            <div class="box">
              <p
                style="padding: 2px 0;"
                v-for="(item, index) in positionDetail.locations"
                :key="index"
              >
                <a
                  :href="
                    'http://api.map.baidu.com/geocoder?address=' +
                      (item.workProvinceName == item.workCityName
                        ? item.workProvinceName
                        : item.workProvinceName + item.workCityName) +
                      item.workAddress +
                      '&output=html&src=webapp.baidu.openAPIdemo'
                  "
                  >{{
                    (item.workProvinceName == item.workCityName
                      ? item.workProvinceName
                      : item.workProvinceName + item.workCityName) +
                      item.workAddress
                  }}</a
                >
                <span class="company-main-tag" v-if="item.addType">{{
                  item.addType
                }}</span>
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="tab-box" v-if="showFullDetail">
        <h2 class="tab-title">职位画像</h2>
        <ul class="tab-list">
          <li>
            <label>硬性要求</label>
            <div class="box">-</div>
          </li>
          <li>
            <label>优先画像</label>
            <div class="box">{{ coCreationVO.bestPortrait || "-" }}</div>
          </li>
          <li>
            <label>一般画像</label>
            <div class="box">{{ coCreationVO.secondPortrait || "-" }}</div>
          </li>
          <!-- <li>
            <label>托底画像</label>
            <div class="box">{{ coCreationVO.basePortrait || "-" }}</div>
          </li> -->
          <li>
            <label>拒绝画像</label>
            <div class="box">{{ coCreationVO.rejectPortrait || "-" }}</div>
          </li>
          <li>
            <label>软性素质</label>
            <div class="box">{{ coCreationVO.softDiathetic || "-" }}</div>
          </li>
          <li>
            <label>管理经验</label>
            <div class="box">
              <div>
                <span>{{
                  coCreationVO.functionType == 2 ? "管理岗" : "否"
                }}</span>
                <span v-if="coCreationVO.functionType == 2"
                  >管理{{ coCreationVO.underlingCount || 0 }}人</span
                >
              </div>
              <div v-if="coCreationVO.functionTypeDescription">
                {{ coCreationVO.functionTypeDescription }}
              </div>
            </div>
          </li>
          <li
            v-if="
              coCreationVO.targetCompanyList &&
                coCreationVO.targetCompanyList.length
            "
          >
            <label>对标公司</label>
            <div
              class="box"
              v-if="
                coCreationVO.targetCompanyList &&
                  coCreationVO.targetCompanyList.length
              "
            >
              <span
                style="margin-right: 10px"
                :key="co"
                v-for="co in coCreationVO.targetCompanyList.split(',')"
                >{{ co }}</span
              >
            </div>
            <div class="box" v-else>-</div>
          </li>
          <li
            v-if="
              coCreationVO.targetCompany && coCreationVO.targetCompany.length
            "
          >
            <label>不看公司</label>
            <div
              class="box"
              v-if="
                coCreationVO.targetCompany && coCreationVO.targetCompany.length
              "
            >
              <span
                style="margin-right: 10px"
                :key="co"
                v-for="co in coCreationVO.targetCompany.split(',')"
                >{{ co }}</span
              >
            </div>
            <div class="box" v-else>-</div>
          </li>
        </ul>
      </div>
      <div
        class="tab-box"
        v-if="
          showFullDetail &&
            (coCreationVO.departmentDetail ||
              coCreationVO.teamDetail ||
              positionDetail.reportTo ||
              coCreationVO.leaderManner ||
              coCreationVO.promotionChannel)
        "
      >
        <h2 class="tab-title">部门介绍</h2>
        <ul class="tab-list">
          <li v-if="coCreationVO.departmentDetail">
            <label>部门情况</label>
            <div class="box">{{ coCreationVO.departmentDetail || "-" }}</div>
          </li>
          <li v-if="coCreationVO.teamDetail">
            <label>团队情况</label>
            <div class="box">{{ coCreationVO.teamDetail || "-" }}</div>
          </li>
          <li v-if="positionDetail.reportTo">
            <label>汇报对象</label>
            <div class="box">{{ positionDetail.reportTo || "-" }}</div>
          </li>
          <li v-if="coCreationVO.leaderManner">
            <label>领导风格</label>
            <div class="box">{{ coCreationVO.leaderManner || "-" }}</div>
          </li>
          <li v-if="coCreationVO.promotionChannel">
            <label>晋升通道</label>
            <div class="box">{{ coCreationVO.promotionChannel || "-" }}</div>
          </li>
        </ul>
      </div>
      <div class="tab-box">
        <h2 class="tab-title">薪资福利</h2>
        <ul class="tab-list">
          <li>
            <label>税前年薪</label>
            <div class="box">
              <span
                >￥{{ positionDetail.annualSalaryDesc }}万<span
                  v-if="
                    positionDetail.positionSurvey &&
                      positionDetail.positionSurvey
                        .annualSalaryBeforeTaxDescription
                  "
                  >({{
                    positionDetail.positionSurvey
                      .annualSalaryBeforeTaxDescription
                  }})</span
                ></span
              >
            </div>
          </li>
          <li
            v-if="
              (positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean
                  .salaryRuleConstitute) ||
                positionDetail.salarySupplement
            "
          >
            <label>薪资构成</label>
            <div class="box">
              <span>{{
                positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean.salaryRuleConstitute
                  ? positionSurveyView.positionSurveyBaseBean
                      .salaryRuleConstitute
                  : positionDetail.salarySupplement
              }}</span>
            </div>
          </li>
          <li
            v-if="
              positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean.socialSecurityBenefits
            "
          >
            <label>社保福利</label>
            <div class="box">
              <span>{{
                positionSurveyView.positionSurveyBaseBean
                  .socialSecurityBenefits || "-"
              }}</span>
            </div>
          </li>
          <li
            v-if="
              positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean.holidayBenefits
            "
          >
            <label>假期福利</label>
            <div class="box">
              <span>{{
                positionSurveyView.positionSurveyBaseBean.holidayBenefits
              }}</span>
            </div>
          </li>
          <li
            v-if="
              positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean.housingBenefits
            "
          >
            <label>住房福利</label>
            <div class="box">
              <span>{{
                positionSurveyView.positionSurveyBaseBean.housingBenefits
              }}</span>
            </div>
          </li>
          <li
            v-if="
              positionSurveyView.positionSurveyBaseBean.phoneTrafficBenefits
            "
          >
            <label>通讯交通</label>
            <div class="box">
              <span>{{
                positionSurveyView.positionSurveyBaseBean.phoneTrafficBenefits
              }}</span>
            </div>
          </li>
          <li
            v-if="
              coCreationVO.enterpriseVO.workOverCost ||
                coCreationVO.enterpriseVO.workOverCostRule
            "
          >
            <label>加班费用</label>
            <div class="box">
              <p v-if="coCreationVO.enterpriseVO.workOverCost">
                <span>{{ coCreationVO.enterpriseVO.workOverCost }}</span>
              </p>
              <p v-if="coCreationVO.enterpriseVO.workOverCostRule">
                <span
                  >【加班费规则】{{
                    coCreationVO.enterpriseVO.workOverCostRule
                  }}</span
                >
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="tab-box">
        <h2 class="tab-title">面试说明</h2>
        <ul class="tab-list">
          <li v-if="interviewAddress">
            <label>面试地址</label>
            <div class="box">
              <span
                ><a
                  :href="
                    'http://api.map.baidu.com/geocoder?address=' +
                      interviewAddress +
                      '&output=html&src=webapp.baidu.openAPIdemo'
                  "
                  >{{ interviewAddress }}</a
                ></span
              >
            </div>
          </li>
          <li
            v-if="
              (positionSurveyView &&
                positionSurveyView.positionSurveyBaseBean &&
                positionSurveyView.positionSurveyBaseBean
                  .interviewRotationNum) ||
                positionDetail.interviewRotationNum
            "
          >
            <label>面试轮次</label>
            <div class="box">
              <span
                >{{
                  positionSurveyView &&
                  positionSurveyView.positionSurveyBaseBean &&
                  positionSurveyView.positionSurveyBaseBean.interviewRotationNum
                    ? positionSurveyView.positionSurveyBaseBean
                        .interviewRotationNum
                    : positionDetail.interviewRotationNum
                }}次</span
              >
            </div>
          </li>
          <li v-else>
            <label>面试轮次</label>
            <div class="box">
              <span
                >{{
                  positionDetail.interviewTimes | interviewTimesFilter
                }}次</span
              >
            </div>
          </li>
          <li
            v-if="
              positionDetail.interviewProcessJson &&
                positionDetail.interviewProcessJson.length
            "
          >
            <label>面试流程：</label>
            <div class="box">
              <p
                class="step-wrap"
                v-for="(interview,
                index) in positionDetail.interviewProcessJson"
              >
                <span v-if="interview.interviewRotationNum">{{
                  interview.interviewRotationNum
                }}</span>
                <span v-if="interview.interviewer">{{
                  interview.interviewer
                }}</span>
                <span v-if="interview.interviewValue">{{
                  interview.interviewValue
                }}</span>
              </p>
            </div>
          </li>
          <li>
            <label>异地面试</label>
            <div class="box">
              <p>{{ positionDetail.interviewOtherPlace ? "是" : "否" }}</p>
              <p v-if="positionDetail.interviewOtherPlaceDescription">
                <span>{{ positionDetail.interviewOtherPlaceDescription }}</span>
              </p>
            </div>
          </li>
          <li>
            <label>报销流程</label>
            <div class="box" v-if="positionDetail.interviewOtherPlace">
              <p>
                <span>{{
                  positionDetail.interviewOtherPlaceReimbursement
                    ? "有报销"
                    : "无报销"
                }}</span>
              </p>
              <p v-if="positionDetail.interviewReimbursementProcess">
                <span>{{ positionDetail.interviewReimbursementProcess }}</span>
              </p>
            </div>
            <div v-else class="box">-</div>
          </li>
        </ul>
      </div>
      <div class="tab-box">
        <h2 class="tab-title">职位JD</h2>
        <ul class="tab-list">
          <li>
            <label>工作职责</label>
            <div class="box">{{ positionDetail.jobDescription || "-" }}</div>
          </li>
          <li>
            <label>任职要求</label>
            <div class="box">{{ positionDetail.jobRequirement || "-" }}</div>
          </li>
        </ul>
      </div>
      <!-- QA -->
      <QaBox
        v-if="
          positionDetail &&
            coCreationVO.hiddenVO &&
            positionDetail.positionClientType != 3
        "
        :qa-list="positionQAList"
        :hidden-obj="coCreationVO.hiddenVO"
        :pa-info="paInfo"
      />
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import QaBox from "../../components/qaBox";
const { positionQAList } = window.METADATA;
export default {
  props: {
    positionDetail: {},
    positionSurveyView: {},
    positionSurvey: {},
  },
  data() {
    return {
      positionQAList: [],
      openReasonTypeMap: {
        1: "新增",
        2: "替换",
        3: "长期有效",
        4: "保密",
      },
    };
  },
  computed: {
    paInfo() {
      return (
        (this.positionDetail.spaViews && this.positionDetail.spaViews[0]) ||
        null
      );
    },
    showQa() {
      let bool = false;
      bool = this.positionQAList.some((i) => i.show == true);
      return bool;
    },
    interviewAddress() {
      const address1 =
        this.positionSurveyView &&
        this.positionSurveyView.positionSurveyBaseBean &&
        this.positionSurveyView.positionSurveyBaseBean.interviewAddress
          ? this.positionSurveyView.positionSurveyBaseBean.interviewAddress
          : "";
      let address2 = "";
      if (this.positionDetail) {
        address2 =
          this.positionDetail.interviewProvince +
          (this.positionDetail.interviewCity !=
          this.positionDetail.interviewProvince
            ? this.positionDetail.interviewCity + " "
            : " ") +
          this.positionDetail.interviewAddress;
      }

      return address1 || address2;
    },
    unLock() {
      return (
        (this.positionDetail &&
          this.positionDetail.coCreationVO &&
          this.positionDetail.coCreationVO.coCreationFlag &&
          this.positionDetail.coCreationRewardDetail &&
          this.positionDetail.coCreationRewardDetail.guidanceService === 1) ||
        !this.positionDetail.coCreationVO ||
        !this.positionDetail.coCreationVO.coCreationFlag ||
        !this.positionDetail.ifCanJoinCoCreation
      );
    },
    coCreationVO() {
      return this.positionDetail && this.positionDetail.coCreationVO
        ? this.positionDetail.coCreationVO
        : {};
    },
    coCreationRewardDetail() {
      return this.positionDetail && this.positionDetail.coCreationRewardDetail
        ? this.positionDetail.coCreationRewardDetail
        : {};
    },
    noGuidanceRewardView() {
      return this.positionDetail &&
        this.positionDetail.coCreationRewardDetail &&
        this.positionDetail.coCreationRewardDetail.noGuidanceRewardView
        ? this.positionDetail.coCreationRewardDetail.noGuidanceRewardView
        : "";
    },
    showFullDetail() {
      return (
        (!this.coCreationVO.coCreationFlag ||
          this.coCreationRewardDetail.guidanceService === 1 ||
          !this.positionDetail.ifCanJoinCoCreation ||
          this.coCreationVO.coCreationScore < 80) &&
        (!this.positionDetail.ccBlackListFlagDTO ||
          (this.positionDetail.ccBlackListFlagDTO &&
            !this.positionDetail.ccBlackListFlagDTO.isCompanyInCcBlack))
      );
    },
  },
  methods: {
    handleAddress() {},
    showTips() {
      Dialog({
        title: "提示",
        message: "猎头用户全流程参与共创职位招聘，平台额外补贴",
      });
    },
    formatQaList() {
      this.positionQAList = JSON.parse(JSON.stringify(positionQAList));
      let hiddenObj = null;
      if (this.positionDetail && this.positionDetail.coCreationVO) {
        hiddenObj = this.positionDetail.coCreationVO.hiddenVO;
      }
      this.positionQAList.forEach((item) => {
        if (hiddenObj) {
          item.show = !hiddenObj[item.key] || false;
          if (item.key == "benefitsVisible") {
            item.show =
              !hiddenObj["socialSecurityBenefitsVisible"] ||
              !hiddenObj["housingBenefitsVisible"] ||
              !hiddenObj["holidayBenefitsVisible"] ||
              !hiddenObj["phoneTrafficBenefitsVisible"] ||
              !hiddenObj["workOverCostVisible"] ||
              false;
          }
        } else {
          item.show = true;
        }
      });
    },
  },
  components: {
    QaBox,
  },
  created() {
    this.formatQaList();
  },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.company-main-tag {
  width: 64px;
  height: 24px;
  line-height: 24px;
  background-color: rgba(245, 245, 245, 1);
  margin-left: 16px;
  text-align: center;
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  display: inline-block;
}

.tab-content {
  padding: 15px 0;
  .co-cr-order {
    position: relative;
    margin-bottom: 20px;
    img {
      width: 100%;
    }
    .content {
      left: 8.16%;
      top: 32%;
      width: 83.67%;
      height: 33.83%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: absolute;
      .left {
        width: 44.26%;
        height: 100%;
        background: url("../../assets/survey-desc-bg.png") no-repeat;
        background-size: 100%;
      }
      .right {
        width: 44.26%;
        height: 100%;
        background: url("../../assets/survey-salary-bg.png") no-repeat;
        background-size: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .p1 {
          font-size: 14px;
          font-weight: 500px;
          color: #000;
          text-align: center;
          .wenhao {
            margin-left: 4px;
          }
        }
        .p2 {
          font-size: 15px;
          font-weight: 700;
          line-height: 24px;
          color: #02b29c;
          text-align: center;
        }
      }
    }
    .bottom-tip {
      left: 3.49%;
      width: 93%;
      bottom: 8%;
      height: 15%;
      position: absolute;
      border-radius: 2px;
      background: #ffeee0;
      color: #cc7c30;
      font-size: 14px;
      font-weight: 400;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      p {
        width: 100%;
      }
    }
  }
  .co-cr-guidance {
    margin-bottom: 20px;
    img {
      width: 100%;
    }
  }
  .tab-box {
    &:not(:last-child) {
      margin-bottom: 20px;
      border-bottom: 0.5px solid #e5e5e5;
    }
    .tab-title {
      font-family: PingFangSC-Semibold;
      margin-bottom: 15px;
    }
    .tab-list {
      li {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 15px;
        label {
          width: 70px;
          min-width: 70px;
          margin-right: 20px;
          color: #666;
        }
        .box {
          white-space: pre-line;
          .step-wrap {
            span {
              &:after {
                content: " > ";
              }
              &:last-child:after {
                display: none;
              }
            }
          }
        }
        .city {
          display: block;
        }
      }
    }
  }
}
</style>
